import { FC, useMemo } from "react"
import { IToothIPRData } from "./index"
import Polyline from "./Polyline"
import "./scss/MyUpPolyline.scss"

interface IProps {
  toothIPRData: IToothIPRData
}
const MyLowPolyline: FC<IProps> = ({ toothIPRData }) => {
  const pl = 26
  const itemWidth = 42
  const width = 878
  const { iprLRToothDataMemo, iprLLToothDataMemo } = toothIPRData
  const toothPos = [
    0, 23, 112, 178, 223, 280, 340, 395, 447, 498, 552, 597, 655, 700, 767, 810,
  ]

  const getLowList = useMemo(() => {
    const lowList = [...iprLRToothDataMemo, ...iprLLToothDataMemo]

    //增加向前索引方法
    const hasNonMissingToothBefore = (currentIndex: number): boolean => {
      for (let i = currentIndex - 1; i >= 0; i--) {
        if (!lowList[i].isMissingTooth) {
          return true
        }
      }
      return false
    }

    const findIndexs = lowList
      .map((item, index) => {
        const indices: (number | undefined)[] = []
        if (index === 0) {
          indices.push(index)
        }
        if (item.isMissingTooth) {
          indices.push(index)
          if (index === 0) indices.push(index + 1)
          // if (index === lowList.length - 1) indices.push(index - 1)
        }

        if (!hasNonMissingToothBefore(index)) {
          indices.push(index)
        }

        return indices
      })
      .flat()
      .filter((item): item is number => item !== undefined)
      .filter((item, index, arr) => arr.indexOf(item) === index)
      .sort((a, b) => a - b)
    const isNotMissingData = lowList.filter(
      (item, index) => !findIndexs.includes(index),
    )

    const toothPosMap = toothPos.filter(
      (item, index) => !findIndexs.includes(index),
    )
    const posData = isNotMissingData.map((item, index) => {
      const left =
        itemWidth * index +
        pl +
        ((width - itemWidth * isNotMissingData.length) /
          (isNotMissingData.length - 1)) *
          index

      return {
        ...item,
        point: [toothPosMap[index], 0, toothPosMap[index], 60, left, 135],
      }
    })

    return posData
  }, [toothIPRData.iprLRToothDataMemo, toothIPRData.iprLLToothDataMemo])

  return (
    <div className="my-low-polyline">
      {getLowList.length > 0 &&
        getLowList.map((item, index) => {
          return (
            <div key={index} className="item-polyline">
              <Polyline point={item.point} />
            </div>
          )
        })}
    </div>
  )
}

export default MyLowPolyline
